import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

import StepDetailsFormContainer from '../../../../containers/projects/ChangeStrategyFormContainers/StepDetailsFormContainer.jsx';

const NewChangeStrategyStepDetails = ({ projectId, slug }) => (
  <>
    <Helmet>
      <title>Edit Change Strategy | ChangeSync</title>
    </Helmet>
    <StepDetailsFormContainer projectId={projectId} slug={slug} />
  </>
);

NewChangeStrategyStepDetails.getInitialProps = ({ query }) => ({
  slug: query.slug,
  projectId: Number(query.projectId),
});

export default requireAuth(withRouterParams(NewChangeStrategyStepDetails));
